import React, { useState, useEffect } from "react";
import { Rating } from '@mui/material';
import { Diamond, LinkedIn } from "@mui/icons-material";
import axios from "axios";
import Badge from '../../assets/SIngleMentor/badge.png';
import exp from '../../assets/SIngleMentor/coach.png';
import map from  '../../assets/SIngleMentor/map.png';
import { useParams } from "react-router-dom/cjs/react-router-dom";
import '../../assets/css/mentor.css'
import SecurityHeaders from "../../data/SecurityHeaders";
import ENDPOINT from "../../context/ENDPOINT";


const SingleMentor = () => {

    const [mentor, setMentor] = useState([]);

    const params = useParams()
    // console.log(params)
    const fetchMentors = async () => {
  
      try {
        const formData = new FormData();
        formData.append("mentor_id",params.id );
  
  
        const res = await axios.post(ENDPOINT+"get-mentor.php", formData,SecurityHeaders);
  
        if (res) {
          console.log(res.data)
          setMentor(res.data.mentor);
        }
      } catch (error) {
        console.error("Error fetching mentors:", error);
      }
    };
  
    useEffect(() => {
      fetchMentors();
    }, []);


  return (
    <div>
      {mentor ?
        <div >
          <div className="">
            <img className="bg_img" src={mentor.cover_img} alt="Background" />
          </div>

          <div className="mentorbox col-12 container bg-light border border-1  mb-4 rounded-3">

        <div className="d-flex justify-content-end text-primary "> 
          
          <a href={mentor.linkedin}>
          <LinkedIn  className="mt-5 me-5" sx={{ fontSize: 40 }} />
          </a>
           
           </div>

            <div className="col-7  col-lg-2  col-md-3 col-sm-4 mx-auto animated-icon">
              <img className="mentortriner ms-5 " src={mentor.profile_pic || "default_profile_url"} alt="Trainer Avatar" />
            </div>

           

            <div className="m-auto mt-3 mb-3 col-2 text-center animated-icon">
              <h5>{mentor.first_name}</h5>
              <hr className="w-100 mb-2" />
            </div>

            <div className="col-7 mx-auto d-flex flex-wrap justify-content-between ">
              <div className="d-flex mb-4 col-12 col-lg-3 text-center animated-icon">
                <div className="col-3 mt-3">
                  <img className="col-8" src={exp} alt="Experience" />
                </div>
                <div className="mt-2">
                  <h5>Experience</h5>
                  <p>{mentor.experience} years</p>
                </div>
              </div>

              <div className="d-flex mb-4 col-12 col-lg-3 text-center animated-icon">
                <div className="col-3 mt-3">
                  <img className="col-8" src={Badge} alt="Rating" />
                </div>
                <div className="mt-2">
                  <h5>Trainer Rating</h5>
                  <Rating name="read-only" value={mentor.ratings} readOnly />
                </div>
              </div>

              <div className="d-flex mb-4 col-12 col-lg-3 text-center animated-icon">
                <div className="col-3 mt-3">
                  <img className="col-8" src={map} alt="Location" />
                </div>
                <div className="mt-2">
                  <h5>Trains At</h5>
                  <p>{mentor.trains_at}</p>
                </div>
              </div>
            </div>
          </div>


          <div className="col-12 mb-5 container mt-5">
            <h4>About</h4>
            <p>{mentor.about || "No information available."}</p>
          </div>


          <div className="col-12 container border border-2 rounded rounded-3 mt-3 p-3 mb-4 animated-icon">
            <h4>Experience</h4>
            <div className="d-flex">
              <div className="col-1">
                <img className="col-12" src={mentor.company_logo || "default_company_logo"} alt="Company" />
              </div>
              <div className="mt-auto ms-2">
                <h5>{mentor.job_title}</h5>
                <p>{mentor.company_name} · {mentor.employment_type}</p>
              </div>
            </div>
            <div className="mt-3 d-flex">
              <Diamond className="me-2" />
              <h6>{mentor.skills}</h6>
            </div>
          </div>

          <div className="col-12 container border border-2 rounded rounded-3 mt-3 p-3 mb-4 animated-icon">
            <h4>Skills</h4>
            <div className="d-flex">
              <div className="col-1">
                <img className="col-12" src={mentor.company_logo || "default_company_logo"} alt="Company" />
              </div>
              <div className="mt-auto ms-2">
                <h5>{mentor.skill_title}</h5>
                <p>{mentor.skill_description}</p>
              </div>
            </div>
          </div>

          <div className="col-12 container border border-2 rounded rounded-3 mt-3 p-3 mb-4 animated-icon">
            <h4>Licence</h4>
            <div className="d-flex">
            
            
            </div>
          </div>

        </div>
        : <p>Loading mentors...</p>}
    </div>
  )
}

export default SingleMentor